"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalEvent = void 0;
/**
 * A in-memory event that allows for subscribing, unsubscribing, and notifying.
 *
 * @typeparam TEventHandler - the event handler signature.  Defaults to EventHandler<any>.
 */
class LocalEvent {
    /**
     * Creates a new LocalEvent.
     * @param eventName Name of the event.  Used for logging.
     */
    constructor(eventName) {
        this.eventName = eventName;
        this.handlers = [];
    }
    /**
     * Subscribes to the event.
     *
     * @param handler - the function to call when the event occurs.
     */
    subscribe(handler) {
        if (!this.handlers.some((h) => h === handler)) {
            this.handlers.push(handler);
        }
    }
    /**
     * Unsubscribes from the event.
     *
     * @param handler - the function to unsubscribe. It must be the same function that was passed to subscribe.
     */
    unsubscribe(handler) {
        this.handlers = this.handlers.filter((h) => h !== handler);
    }
    /**
     * Notifies all subscribers of the event, passing the arguments to the subscribed handlers.
     *
     * @param args - arguments to pass to the event handlers.
     */
    notify(...args) {
        this.handlers.forEach((handler) => {
            try {
                handler(...args);
            }
            catch (ex) {
                // not using logging.warn to avoid circular reference
                console.warn(`Problem notifying event '${this.eventName}' subscriber:`, ex);
            }
        });
    }
    /**
     * Clears all subscribers.
     */
    clearAll() {
        this.handlers = [];
    }
}
exports.LocalEvent = LocalEvent;
